import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getMeApi } from "services/apis/auth";
import webStorage from "utils/webStorage";

export const getMe = createAsyncThunk("auth/GET_ME", async (params, { rejectWithValue }) => {
  try {
    const response = await getMeApi(params);
    return response;
  } catch (error) {
    return rejectWithValue(error.data);
  }
});

const initialState = {
  currentUser: null,
  userInfo: {},
  isAuth: webStorage.get("isAuth") || false,
  isFirstAccess: true,
  loading: false,
  error: null,
  role: webStorage.get("role") || "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    resetState: (state, action) => {
      const fieldName = action.payload;
      state[fieldName] = initialState[fieldName];
    },

    removeToken: state => {
      state.isAuth = false;
      state.isFirstAccess = false;
      state.currentUser = null;
      state.loading = false;
      state.error = {};
      webStorage.removeAll();
    },

    actionLogin: (state, action) => {
      state.isAuth = action.payload.isAuth || false;
      state.userInfo = action.payload.userInfo || null;
      state.loading = false;
      state.error = {};
      webStorage.set("isAuth", true);
    },

    actionLogout: state => {
      state.isAuth = false;
      state.userInfo = null;
      state.loading = false;
      state.error = {};
      webStorage.removeAll();
    },
  },

  extraReducers: builder => {
    builder
      .addCase(getMe.pending, state => {
        state.loading = true;
      })
      .addCase(getMe.rejected, (state, action) => {
        state.loading = false;
        state.isAuth = false;
        state.error = action?.payload?.errors;
        state.isAuth = false;
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.errors) {
          state.error = action.payload?.errors;
          state.isAuth = false;
        } else {
          state.isAuth = true;
          state.currentUser = action.payload;
          state.role = action.payload?.user?.role;
        }
      });
  },
});

export const { resetState, removeToken, actionLogin, actionLogout } = authSlice.actions;
const { reducer: authReducer } = authSlice;
export default authReducer;
